import React, { Component } from 'react';
// import { connect } from 'react-redux';
import { crudCreate, SaveButton } from 'react-admin';

// A custom action creator which modifies the values before calling the default crudCreate action creator
// const saveWithOrderId = (values, basePath, redirectTo, orderId) =>
//     crudCreate('sap_sdo_for_orders', { ...values, sap_digital_order_id: orderId }, basePath, redirectTo);

class SaveWithOrderIdButtonView extends Component {
    handleClick = () => {
        const { basePath, handleSubmit, saveWithOrderId, orderId, data } = this.props;
        const businessId = this.props.data.data.location.state.order.id;
        // const orderId = this.props.data.data.location.state.order.business_id;
        const bussinessId = this.props.data.location.state.order.business_id;
        console.log('33333333333333',this.props);

        return handleSubmit(values => {
            saveWithOrderId(values, basePath, `/sap_digital_orders/${bussinessId}/show/2`, bussinessId);
        });
    };

    render() {
        const { handleSubmitWithRedirect, saveWithOrderId, orderId, ...props } = this.props;

        return (
            <SaveButton
                handleSubmitWithRedirect={this.handleClick}
                {...props}
            />
        );
    }
}

const SaveWithOrderIdButton = SaveWithOrderIdButtonView
// connect(
//     undefined,
//     { saveWithOrderId }
// )(SaveWithOrderIdButtonView);

export default SaveWithOrderIdButton;